import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  closeProductModal,
  refreshProductList,
} from "../../../redux/features/productModalSlice";

import { AddUnit } from "../../../redux/services/UnitService/unit.Services";
import Swal from "sweetalert2";
import { successToast } from "../../../Utils/toast";

function CreateBrand({ refreshData }) {
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    shortname: "",
    status: 1,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };
  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = ["Unit is required"];
    }

    setErrors(newErrors);
    return newErrors;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
        const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setTimeout(() => {
        const firstErrorField = document.querySelector(".is-invalid");
        if (firstErrorField) {
          firstErrorField.focus();
          firstErrorField.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
      return;
    }
    try {
      const res = await AddUnit(formData);

      if (res?.data?.success) {
        successToast(res?.data.message);
        dispatch(refreshProductList());
        dispatch(closeProductModal());
      }
    } catch (error) {
      console.log(error);
       if (error?.response?.status === 422) {
              setErrors(error.response.data.errors || {});
            } else {
              Swal.fire("Error", "Something went wrong", "error");
            }
          
    }
  };

  return (
    <form onSubmit={handleSubmit}>
       <div className="mb-3">
        <label>Units</label>
      <input
        type="text"
          name="name"
           className={`form-control ${errors?.name ? "is-invalid" : ""}`}
        placeholder="Unit Name"
        value={formData.name}
        onChange={(e) =>
          setFormData({
            ...formData,
            name: e.target.value,
          })
        }
      />
         {errors?.name && (
          <div className="invalid-feedback d-block">
            {Array.isArray(errors.name) ? errors.name[0] : errors.name}
          </div>
        )}
</div>
       {/* <div className="mb-3">
      <input
        type="text"
          name="short_name"
           className={`form-control ${errors?.shortname ? "is-invalid" : ""}`}
        placeholder="Unit Name"
        value={formData.shortname}
        onChange={(e) =>
          setFormData({
            ...formData,
            name: e.target.value,
          })
        }
      />
         {errors?.name && (
          <div className="invalid-feedback d-block">
            {Array.isArray(errors.shortname) ? errors.shortname[0] : errors.shortname}
          </div>
        )}
</div> */}

      <button className="add-btn">
        Create Unit
      </button>
    </form>
  );
}

export default CreateBrand;